import { nanoid } from 'nanoid'
import { AxiosError } from 'axios'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type IResponseHubspotList, IntegrationsApi } from 'entities/Integrations'

const makeSyncAction = (listId: number, onRemoveListLocal: () => void): ActionItem => ({
  icon: 'refresh',
  text: 'Refresh',
  onAction: async () => {
    try {
      await IntegrationsApi.resyncHubspotLists(listId)
    } catch (e) {
      if (e instanceof AxiosError) {
        const message = e.errors.getError('message')
        if (message) {
          toastStore.add({
            type: 'error',
            title: message,
          })

          if (['Not Found', 'List deleted in HubSpot.'].includes(message)) {
            onRemoveListLocal()
          }
        }
      }
      logger.error(e)
    }
  },
})

const makeDeleteAction = (onRemoveList: () => void): ActionItem => {
  const onDelete = () => {
    const id = nanoid()
    modalStore.addModal({
      id,
      type: ModalTypeList.ALERT,
      title: 'Delete synced hubspot list?',
      desc: 'This action cannot be undone',
      primaryAction: {
        text: 'Delete',
        onAction: () => {
          onRemoveList()
          modalStore.closeModal(id)
        },
      },
      secondaryAction: {
        text: 'Cancel',
        onAction: () => {
          modalStore.closeModal(id)
        },
      },
    })
  }
  return {
    icon: 'delete',
    text: 'Remove list',
    onAction: onDelete,
  }
}

export const getPowerHubspotListActions = (
  hubspotList: IResponseHubspotList,
  onRemoveList: () => void,
  onRemoveListLocal: () => void
): ActionItem[] => {
  const syncAction = makeSyncAction(hubspotList.id, onRemoveListLocal)
  const deleteAction = makeDeleteAction(onRemoveList)

  return [syncAction, deleteAction]
}
